<template>
    <div class="transaction-section-bar">
        <div class="transaction-section-tabs" role="tablist" aria-label="Transaction document sections">
            <button v-for="tab in tabs" :key="tab.id" :ref="`section-tab-${tab.id}`" type="button"
                :id="`section-tab-${tab.id}`" role="tab" :aria-controls="`section-panel-${tab.id}`"
                :aria-selected="current_tab === tab.id" :tabindex="current_tab === tab.id ? 0 : -1"
                :class="{ selected: current_tab === tab.id }" @click="selectTab(tab.id)" @keydown="navigateTabs($event, tab.id)">
                <svg v-if="tab.id === 'documents'" class="section-tab-icon" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
</svg>
                <i v-else class="fa fa-pen-nib section-tab-icon" aria-hidden="true"></i>
                {{ tab.label }}
            </button>
        </div>
        <a v-if="back_route" :href="back_route" class="envelope-back-link"><arrow-left-icon size="14" aria-hidden="true" />Back to Envelopes</a>
    </div>
</template>

<script>
import { ArrowLeftIcon } from 'vue-feather-icons';

export default {
    components: { ArrowLeftIcon },
    props: {
        back_route: { default: null },
        current_tab: { default: 'documents' },
        includes_signatures: { default: true },
        documents_index_route: {},
        signatures_index_route: {},
    },
    computed: {
        tabs() {
            return [
                { id: 'documents', label: 'Documents' },
                ...(this.includes_signatures ? [{ id: 'signatures', label: 'Signatures' }] : []),
            ];
        },
    },
    methods: {
        selectTab(id) {
            const route = id === 'documents' ? this.documents_index_route : this.signatures_index_route;
            if (route) window.location.href = route;
            else this.$emit('change', id);
        },
        navigateTabs(event, currentTab) {
            const index = this.tabs.findIndex(tab => tab.id === currentTab);
            const count = this.tabs.length;
            const positions = { ArrowRight: (index + 1) % count, ArrowLeft: (index + count - 1) % count, Home: 0, End: count - 1 };
            if (!(event.key in positions)) return;
            event.preventDefault();
            const id = this.tabs[positions[event.key]].id;
            this.selectTab(id);
            this.$nextTick(() => this.$refs[`section-tab-${id}`][0].focus());
        },
    },
};
</script>

<style scoped>
.transaction-section-bar { display: flex; align-items: center; flex-wrap: wrap; gap: 0.5rem 1rem; border-bottom: 1px solid #d1d5db; margin-bottom: 1.25rem; }
.transaction-section-tabs { display: flex; gap: 1.5rem; }
.envelope-back-link { display: inline-flex; align-items: center; gap: 0.375rem; margin-left: auto; padding: 0.5rem 0; font-size: 0.8125rem; color: #6b7280; }
.envelope-back-link:hover { color: #2563eb; text-decoration: underline; }
.transaction-section-tabs button { display: inline-flex; align-items: center; gap: 0.625rem; padding: 0.75rem 0.375rem; margin-bottom: -1px; border-bottom: 3px solid transparent; font-size: 1.25rem; font-weight: 600; color: #9ca3af; }
.section-tab-icon { width: 1.5rem; height: 1.5rem; flex: none; font-size: 1.375rem; line-height: 1.5rem; }
.transaction-section-tabs button:hover { color: #2563eb; }
.transaction-section-tabs button.selected { border-bottom-color: #2563eb; color: #2563eb; }
.transaction-section-tabs button:focus { outline: none; box-shadow: none; }
</style>
